module.exports = __webpack_public_path__ + "static/img/RGH-sectors-First-Arrows-2sections.b0a85db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/RGH-sectors-First-Arrows-2sections.png
// module id = ARDz
// module chunks = 1